module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerut0a-ch0401",
      "epub:type": "division",
      "id": "ut0a-ch04"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerut0a-ch0401"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20005#toc"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("US House, John Bingham, Proposed Amendment")]), _vm._v(" "), _c('h1', {
    staticClass: "cs",
    attrs: {
      "role": "doc-subtitle"
    }
  }, [_vm._v("December 6, 1865"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chilashvol20268#fn5",
      "id": "fn5r",
      "role": "doc-noteref"
    }
  }, [_vm._v("5†")])])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ahaft",
    attrs: {
      "id": "ahaft0701"
    }
  }, [_vm._v("Rebel Debt.")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("Mr. BINGHAM also introduced a joint resolution providing for an amendment to the Constitution of the United States forbidding the payment or assumption by the United States or by any State of any debt which has been or may hereafter be contracted in aid of any rebellion against the United States; which was read a first and second time, and ordered to be referred to the Committee on the Judiciary, when appointed, and to be printed.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0701"
    }
  }, [_vm._v("Equality before the Law.")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Mr. BINGHAM also introduced a joint resolution to amend the Constitution of the United States so as to empower Congress to pass all necessary and proper laws to secure to all persons in every State of the Union equal protection in their rights, life, liberty, and property; "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "23",
      "id": "p23",
      "role": "doc-pagebreak"
    }
  }), _vm._v("which was read a first and second time, and ordered to be referred to the Committee on the Judiciary, when appointed, and to be printed.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25281de6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-lash-vol2-0014.vue
// module id = 93
// module chunks = 0